<div class="checkbox-list" (keydown)="onListKeydown($event)">
<div class="checkbox-list-item checkbox checkbox-inline" [ngClass]="{'nested':item.isNested==true}" *ngFor="let item of items; let i = index">
  <input type="checkbox" id="{{idPrefix}}-{{i}}" value="option1" [(ngModel)]="item.isChecked" (change)="onItemToggle(item)">
  <label for="{{idPrefix}}-{{i}}" title="{{item.display}}"> {{item.display}} </label>
  <p-toggleswitch [ngModel]="!item.isPrimary" (onChange)="handlePrimary(item)" [ngClass]="{'hide':!item.isChecked}" styleClass="axisToggle"  ></p-toggleswitch>
</div>
</div>
